import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { List } from 'APP/components/List/List';
import { IForwardTargetData } from 'APP/main/PopupManager/components/ShareDataView/ShareDataView.types';
import { ShareDataViewListContainer } from 'APP/main/PopupManager/components/ShareDataView/ShareDataViewListContainer/ShareDataViewListContainer';
import { SharedDataContactItem } from 'APP/main/PopupManager/components/ShareDataView/SharedDataContactItem/SharedDataContactItem';
import Entities from 'STORE';

import {
  ICallSelectSpeakersListParams,
  useCallSelectSpeakersListPresenter,
} from './CallSelectSpeakersList.presenter';

export const CallSelectSpeakersList: FC<ICallSelectSpeakersListParams> = observer((props) => {
  const presenter = useCallSelectSpeakersListPresenter(props);

  const renderItem = (item: IForwardTargetData): ReactElement => {
    return (
      <SharedDataContactItem
        data={item.data}
        isSelected={item.isSelected}
        isDisabled={item.data.id === Entities.usersStore.Me.id}
        withCheckbox={true}
        onClick={item.onClick}
      />
    );
  };

  return (
    <ShareDataViewListContainer>
      <List
        data={presenter.content}
        keyExtractor={presenter.keyExtractor}
        renderItem={renderItem}
        ListEmptyComponent={
          <InfoBlock
            descriptions={presenter.infoBlockDescriptions}
            type={InfoBlockTypes.Modal}
            image={
              !props.searchValue
                ? getMascotImageSrc(PROJECT_CONFIG.imageAssets.contacts)
                : getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)
            }
          />
        }
      />
    </ShareDataViewListContainer>
  );
});
